module.exports = __webpack_public_path__ + "static/media/BUX-BNB.98c1b78d.svg";